<template>
  <div class="find-game-by-vendor">
    <van-nav-bar :title="searchParams?.title" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="h-[calc(100vh-56px)] overflow-hidden">
      <div class="m-[8px]">
        <div class="search-box">
          <input v-model="findGameByVendorSearchParams.gameName" @keydown.enter.stop="onSearch"
            class="search-input auth-input" type="text" :placeholder="t('findGameByVendor.searchPlaceholder')">
          <img :src="getAssetsFile('game/fangda.png')" alt="" class="w-[17px] h-[16px]" @click="onSearch"
            style="object-fit: contain;">
        </div>
      </div>
      <div class="mt-[8px] h-[calc(100%-68px)] overflow-hidden mx-[10px] flex">
        <div class="w-[73px] h-full overflow-y-auto mr-[7px] flex-shrink-0">
          <div v-for="(item, index) in vendorList" :key="index" @click="onVendorClick(item)"
            :class="{ 'bg-gradient-to-r from-[#FFE60A] to-[#FFC200]': item.active }"
            class="mb-[15px] w-full h-[60px] bg-[linear-gradient(to_right,#007E5B_0%,#007E5B_50%,#006C4C_100%)] rounded-[5px] flex justify-center items-center">
            <div>
              <div class="flex justify-center items-center">
                <div class="max-w-[30px] h-[30px] flex justify-center items-center">
                  <img class="max-w-full max-h-full w-auto h-auto saturate-10" :class="{ 'saturate-100': item.active }"
                    :src="getVendorIcon(item)" alt="">

                </div>
              </div>
              <div class="flex justify-center items-center">
                <div class="text-[10px] text-bold text-[#4CAE83]" :class="{ 'teonse': item.active }">{{
                  item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full h-full">
          <div class="mt-[1.5px] max-w-full h-[26px] overflow-x-auto overflow-y-hidden">
            <div class="flex pr-[10px]">
              <div @click="onQuickOptionClick(item)" v-for="(item, index) in findGameByVendorQuickOptionList"
                :key="index" :class="{
                  'text-[#fff] bg-[#006849]': item.active,
                  'border border-solid border-[#009F76]': !item.active,
                  'mr-[10px]': index !== findGameByVendorQuickOptionList.length - 1
                }"
                class="text-[#4CAE83] w-[60px] h-[26px] rounded-[5px] text-[10px] flex justify-center items-center flex-shrink-0">
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="h-[calc(100%-26px)] pt-[10px]">
            <div class="h-full overflow-y-auto" @scroll="handleScroll">
              <div class="game-list grid grid-cols-3 gap-x-[0px] gap-y-[36px] sm:gap-y-[30px]">
                <Game class="!h-[100px]" v-for="item in games" :key="item.id" height="150px" :game="item"
                  :show-favorite="true" :show-hot="true" @update:game="updateGame(item)" @click="gogames(item)"></Game>
              </div>
              <!-- 加载状态 -->
              <div v-if="loading" class="flex justify-center items-center py-4">
                <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.loading') }}</div>
              </div>

              <!-- 没有更多数据 -->
              <div v-if="!hasMore && games.length > 0" class="flex justify-center items-center py-4">
                <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.noMoreGames') }}</div>
              </div>

              <!-- 空状态 -->
              <div v-if="!loading && games.length === 0" class="flex justify-center items-center py-8">
                <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.noGamesFound') }}</div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>

  <!-- 移除 AuthDialog 组件，因为现在是全局的 -->
  <!-- <AuthDialog :show="showAuthDialog" :is-login="isLoginMode" @close="handleClose" @switch="handleSwitch" /> -->
</template>

<script setup lang="ts">
import { Game } from "@/components/Game"
import { Button } from "@/components/Button"
import { FindGameByVendor } from '@/api/findGameByVendor'
import * as GameApi from '@/api/game'
import { useUserStore } from '@/stores/modules/user'
import useUIStore from '@/stores/modules/ui'
// 移除 AuthDialog 导入，因为现在是全局的
// import AuthDialog from '@/components/AuthDialog.vue'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
// 移除认证弹窗工具函数导入，因为现在是全局的
// import { showLoginDialog } from '@/utils/auth-dialog'

// 游戏类型映射枚举 - 将前端类型名称映射到后端接口类型名称
const GAME_TYPE_MAPPING = {
  // 前端类型名称 -> 后端接口类型名称
  'SLOTS': 'SLOTS',        // 老虎机
  'FISH': 'FISH',          // 捕鱼
  'Cartas': 'CHESS',       // 棋牌
  'Cassino': 'LIVE', // 真人
  'Arcades': 'ARCADES',    // 街机
} as const

const SLOTS = getAssetsFile('game/gameTypeSlot.png')
const FISH = getAssetsFile('game/FISHING_on.png')
const Cartas = getAssetsFile('game/CHESS_on.png')
const Cassino = getAssetsFile('game/VIDEO_on.png')
const LIVE = getAssetsFile('game/gameTypeSlot.png')
const Arcades = getAssetsFile('game/jieJi.png')
const typeImgs = ref({
  SLOTS,
  FISH,
  Cassino,
  LIVE,
  Cartas,
  Arcades,
})

const imgBaseUrl = import.meta.env.VITE_IMG_URL
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const uiStore = useUIStore()
const { t } = useI18n()
const page = ref<FindGameByVendor.Page>({
  pageNo: 1,
  pageSize: 100,
  total: 0,
})
const searchParams = ref<{
  id: number,
  icon: string,
  title: string,
  active: boolean,
  type: string
}>()
const findGameByVendorSearchParams = ref<FindGameByVendor.SearchParams>({
  vendorId: undefined,
  categoryCode: undefined,
  gameType: undefined,
  gameName: undefined,
  tag: undefined
})
const allVendorItem = ref<FindGameByVendor.Vendor & { active?: boolean } & any>({
  vendorId: undefined,
  name: '',
  logo: "",
  active: true
})
const vendorList = ref<(FindGameByVendor.Vendor & { active?: boolean })[]>([])
const games = ref<FindGameByVendor.Game & { tag: number }[]>([])
const findGameByVendorQuickOptionList = ref([
  {
    label: t('findGameByVendor.all'),
    value: undefined,
    active: true
  },
  {
    label: t('findGameByVendor.popular'),
    value: 'popular',
    active: false
  },
  {
    label: t('findGameByVendor.recent'),
    value: 'recente',
    active: false
  },
  {
    label: t('findGameByVendor.favorites'),
    value: 'favoritos',
    active: false
  }

])
// 移除本地的认证弹窗状态管理
// const showAuthDialog = ref(false)
// const isLoginMode = ref(true)

const loading = ref(false)
const hasMore = ref(true)

const isJson = (str: string) => {
  try {
    JSON.parse(str)
    return true
  } catch (error) {
    return false
  }
}
const updateGame = (game: FindGameByVendor.Game & { tag: number }) => {
  console.log('updateGame', game)
  game.collect = !game.collect
}
// 添加一个函数来处理供应商图标的路径
// 添加一个函数来处理供应商图标的路径
const getVendorIcon = (item: any) => {
  console.log('=== getVendorIcon debug ===')
  console.log('item:', item)
  console.log('item.id:', item.id)
  console.log('item.vendorId:', item.vendorId)
  console.log('item.icon:', item.icon)
  console.log('item.logo:', item.logo)
  console.log('imgBaseUrl:', imgBaseUrl)

  // 检查是否是第一个项目（allVendorItem）
  // 第一个项目通常没有 id 字段，或者有其他特殊标识
  if (!item.id && item.vendorId === undefined) {
    console.log('First item (allVendorItem), returning:', item.icon || '')
    return item.icon || ''
  }

  // 对于其他项目，需要拼接 imgBaseUrl
  if (item.icon) {
    const result = imgBaseUrl + item.icon
    console.log('Using icon, returning:', result)
    return result
  }

  if (item.logo) {
    const result = imgBaseUrl + item.logo
    console.log('Using logo, returning:', result)
    return result
  }

  console.log('No icon or logo found, returning empty string')
  return ''
}

// 滚动加载更多
const handleScroll = (e: Event) => {
  const target = e.target as HTMLElement
  const { scrollTop, scrollHeight, clientHeight } = target

  console.log('滚动检测:', {
    scrollTop,
    scrollHeight,
    clientHeight,
    isNearBottom: scrollTop + clientHeight >= scrollHeight - 10,
    loading: loading.value,
    hasMore: hasMore.value,
    shouldLoad: scrollTop + clientHeight >= scrollHeight - 10 && !loading.value && hasMore.value
  })

  // 滚动到底部时加载更多
  if (scrollTop + clientHeight >= scrollHeight - 10 && !loading.value && hasMore.value) {
    console.log('触发加载更多')
    loadMore()
  }
}

// 加载更多数据
const loadMore = async () => {
  if (loading.value || !hasMore.value) return

  loading.value = true
  page.value.pageNo += 1

  try {
    // 获取映射后的后端类型名称用于 categoryCode
    const frontendGameType = searchParams.value?.type
    const backendGameType = GAME_TYPE_MAPPING[frontendGameType as keyof typeof GAME_TYPE_MAPPING] || frontendGameType

    // 更新搜索参数中的 categoryCode 为映射后的后端类型
    const searchParamsWithMappedType = {
      ...findGameByVendorSearchParams.value,
      categoryCode: backendGameType
    }

    console.log('加载更多参数 - 前端类型:', frontendGameType, '映射后的 categoryCode:', backendGameType)
    console.log('请求参数:', { ...page.value, ...searchParamsWithMappedType })

    const quickOption = findGameByVendorQuickOptionList.value.find(item => item.active)
    let res: any

    if (!quickOption.value) {
      res = await FindGameByVendor.getAllGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'popular') {
      res = await FindGameByVendor.getPopularGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'recente') {
      res = await FindGameByVendor.getRecenteGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'favoritos') {
      // 获取收藏游戏，传递vendorId和gameType参数
      // vendorId 从 findGameByVendorSearchParams 中获取（点击厂商时设置）
      // gameType 从 findGameByVendorSearchParams 中获取（页面初始化时设置）
      const collectParams = {
        ...page.value,
        vendorId: findGameByVendorSearchParams.value.vendorId, // 使用点击厂商时设置的vendorId
        gameType: findGameByVendorSearchParams.value.gameType, // 使用页面初始化时设置的gameType
      }
      console.log('收藏游戏请求参数 (loadMore):', collectParams)
      res = await FindGameByVendor.getFavoritosGames(collectParams)
    }

    if (res.data.list && res.data.list.length > 0) {
      games.value.push(...res.data.list)
      page.value.total = res.data.total

      console.log('加载更多分页信息:', {
        currentPage: page.value.pageNo,
        pageSize: page.value.pageSize,
        newListLength: res.data.list.length,
        totalGames: games.value.length,
        total: res.data.total,
        backendPageNo: res.data.pageNo,
        backendPageSize: res.data.pageSize
      })

      // 判断是否还有更多数据
      // 根据当前已加载的游戏数量和总数来判断
      const currentTotal = games.value.length
      if (currentTotal >= res.data.total) {
        console.log('已加载完所有数据')
        hasMore.value = false
      } else {
        console.log('还有更多数据可以加载')
        hasMore.value = true
      }
    } else {
      // 没有更多数据了
      console.log('没有更多数据')
      hasMore.value = false
    }
  } catch (error) {
    console.error('加载更多失败:', error)
    page.value.pageNo -= 1 // 恢复页码
  } finally {
    loading.value = false
  }
}

const onClickLeft = () => {
  // 跳转到首页并打开侧边菜单栏
  router.push({ name: 'home' }).then(() => {
    // 使用 nextTick 确保页面渲染完成后再打开侧边栏
    nextTick(() => {
      uiStore.openSidebar()
    })
  })
}

const onVendorClick = (item: FindGameByVendor.Vendor & { active?: boolean }) => {
  vendorList.value.forEach(item => {
    item.active = false
  })
  item.active = true
  page.value.pageNo = 1
  // 如果是"全部"厂商（没有id字段），vendorId设置为undefined；否则使用item.id
  findGameByVendorSearchParams.value.vendorId = item.id || undefined
  console.log('点击厂商:', item.name, 'vendorId:', findGameByVendorSearchParams.value.vendorId)
  console.log('当前搜索参数:', findGameByVendorSearchParams.value)
  getGameList()
}

const onQuickOptionClick = (item: { label: string, value: string, active: boolean }) => {
  findGameByVendorQuickOptionList.value.forEach(item => {
    item.active = false
  })
  item.active = true
  findGameByVendorSearchParams.value.gameName = undefined
  page.value.pageNo = 1
  console.log('点击快速选项:', item.label, 'value:', item.value)
  console.log('当前搜索参数:', findGameByVendorSearchParams.value)
  getGameList()
}
const getVendorList = async () => {
  console.log('=== getVendorList debug ===')
  console.log('当前 searchParams.value:', searchParams.value)

  // 传递 gameType 参数，从路由参数中获取并映射到后端接口类型
  const frontendGameType = searchParams.value?.type
  const backendGameType = GAME_TYPE_MAPPING[frontendGameType as keyof typeof GAME_TYPE_MAPPING] || frontendGameType
  console.log('前端类型:', frontendGameType, '映射后的后端类型:', backendGameType)

  if (!backendGameType) {
    console.error('缺少 gameType 参数，无法获取厂商列表')
    return
  }

  const res = await FindGameByVendor.getVendorList(backendGameType)
  vendorList.value = [allVendorItem.value, ...res.data]
  console.log(vendorList.value, '激动哇接地极哇')
  if (vendorList.value.length > 0) {

    page.value.pageNo = 1

    getGameList()
  }
}
const onSearch = () => {
  if (findGameByVendorSearchParams.value.gameName?.trim() === '') {
    return
  } else {
    findGameByVendorQuickOptionList.value.forEach((item, index) => {
      if (index == 0) {
        item.active = true
      } else {
        item.active = false
      }

    })

  }
  page.value.pageNo = 1
  getGameList()
}
const getGameList = async () => {
  // 重置状态
  page.value.pageNo = 1
  hasMore.value = true
  loading.value = true

  try {
    // 获取映射后的后端类型名称用于 categoryCode
    const frontendGameType = searchParams.value?.type
    const backendGameType = GAME_TYPE_MAPPING[frontendGameType as keyof typeof GAME_TYPE_MAPPING] || frontendGameType

    // 更新搜索参数中的 categoryCode 为映射后的后端类型
    const searchParamsWithMappedType = {
      ...findGameByVendorSearchParams.value,
      categoryCode: backendGameType
    }

    console.log('游戏查询参数 - 前端类型:', frontendGameType, '映射后的 categoryCode:', backendGameType)
    console.log('请求参数详情:', { ...page.value, ...searchParamsWithMappedType })

    const quickOption = findGameByVendorQuickOptionList.value.find(item => item.active)
    let res: any
    if (!quickOption.value) {
      res = await FindGameByVendor.getAllGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'popular') {
      res = await FindGameByVendor.getPopularGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'recente') {
      res = await FindGameByVendor.getRecenteGames({ ...page.value, ...searchParamsWithMappedType })
    } else if (quickOption.value === 'favoritos') {
      // 获取收藏游戏，传递vendorId和gameType参数
      // vendorId 从 findGameByVendorSearchParams 中获取（点击厂商时设置）
      // gameType 从 findGameByVendorSearchParams 中获取（页面初始化时设置）
      const collectParams = {
        ...page.value,
        vendorId: findGameByVendorSearchParams.value.vendorId, // 使用点击厂商时设置的vendorId
        gameType: findGameByVendorSearchParams.value.gameType, // 使用页面初始化时设置的gameType
      }
      console.log('收藏游戏请求参数 (getGameList):', collectParams)
      res = await FindGameByVendor.getFavoritosGames(collectParams)
    }

    if (res.data.list && res.data.list.length > 0) {
      games.value = res.data.list
      page.value.total = res.data.total

      console.log('分页信息:', {
        currentPage: page.value.pageNo,
        pageSize: page.value.pageSize,
        currentListLength: res.data.list.length,
        total: res.data.total,
        backendPageNo: res.data.pageNo,
        backendPageSize: res.data.pageSize,
        backendTotalPages: res.data.totalPages
      })

      // 判断是否还有更多数据
      // 根据当前已加载的游戏数量和总数来判断
      const currentTotal = games.value.length
      if (currentTotal >= res.data.total) {
        console.log('已加载完所有数据')
        hasMore.value = false
      } else {
        console.log('还有更多数据可以加载')
        hasMore.value = true
      }
    } else {
      games.value = []
      hasMore.value = false
    }
  } catch (error) {
    console.error('获取游戏列表失败:', error)
    games.value = []
    hasMore.value = false
  } finally {
    loading.value = false
  }
}

const gocollect = (item) => {
  GameApi.collect({ gameId: item.id }).then((res) => {
    item.collect = true
  })
}
const gocollect2 = (item) => {
  GameApi.uncollect({ gameId: item.id }).then((res) => {
    item.collect = false
  })
}
const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
async function gogames(row) {
  const a = userStore.checkLoginStatus()
  if (a) {
    const gamesid = {
      platformId: row.providerId,
      currency: VITE_PLATFORM,
      disableFullScreen: 0,
      gameId: row.gameCode,
      lang: 'en',
      homeUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
      platform: 'H5',
      id: row.id,
    }
    const gameUrl = await GameApi.thirdPartygoGame(gamesid)

    // 记录来源路径
    sessionStorage.setItem('fromPath', route.path)

    // 使用 query 参数传递 URL
    router.push({
      path: '/webview/index2',
      query: {
        rid: gameUrl.data,
      },
    })
  }
  else {
    window.$showLoginDialog() // 使用全局函数
  }
}

onMounted(() => {
  console.log('=== findGameByVendor onMounted 调试 ===')
  console.log('route.query:', route.query)
  console.log('route.query.item:', route.query.item)
  console.log('isJson(route.query.item):', route.query.item ? isJson(route.query.item as string) : false)

  // 先检查路由参数
  if (route.query.item && isJson(route.query.item as string)) {
    searchParams.value = JSON.parse(route.query.item as string)
    console.log('解析后的 searchParams.value:', searchParams.value)

    // 使用映射后的后端类型名称设置 categoryCode 和 gameType
    const frontendGameType = searchParams.value.type
    const backendGameType = GAME_TYPE_MAPPING[frontendGameType as keyof typeof GAME_TYPE_MAPPING] || frontendGameType
    findGameByVendorSearchParams.value.categoryCode = backendGameType
    findGameByVendorSearchParams.value.gameType = backendGameType // 设置 gameType 用于收藏接口

    console.log('初始化参数 - 前端类型:', frontendGameType, '映射后的 categoryCode:', backendGameType, 'gameType:', backendGameType)
    console.log('GAME_TYPE_MAPPING:', GAME_TYPE_MAPPING)

    route.meta.title = searchParams.value.title
    allVendorItem.value.icon = typeImgs.value[searchParams.value.type]
    allVendorItem.value.active = true
    allVendorItem.value.name = t('findGameByVendor.all') + searchParams.value.title

    // 参数设置完成后再调用接口
    getVendorList()
  } else {
    console.error('缺少必要的路由参数 item')
    console.error('route.query.item 值:', route.query.item)
    console.error('route.query.item 类型:', typeof route.query.item)
    router.back()
  }
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.find-game-by-vendor {
  height: 100vh;
  overflow: hidden;
}

.search-box {
  border: 1px solid #009f76;
  border-radius: 6px;
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #00563a;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 17px;
  height: 100%;
}

input::placeholder {
  color: #096;
  font-size: 14px;
}

.search-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 4px;
  display: flex;
  align-items: center;
}

.auth-input {
  caret-color: #50d38c;
}

.game-card {
  border-radius: 10px;
  text-align: center;
  position: relative;
  overflow: hidden;
  width: 79px;
  height: 106px;
  /* 确保卡片有固定高度 */
}

.teonse {
  color: #183009 !important;
  font-weight: bold;
}
</style>
<route lang="json5">
    {
      name: 'findGameByVendor',
      path: '/findGameByVendor'
    }
</route>
